import React, { useState, useEffect } from "react";
import { ref, onValue, update, remove } from "firebase/database";
import db from "../FireBase/firebase";
import "../CSS/mesureSettings.css";

function MesureSettings({ name, isChecked, onChange }) {
  const [editedParam, setEditedParam] = useState(null);
  const [isModified, setIsModified] = useState(false);
  const [localName, setLocalName] = useState(name); // État local pour le nom

  useEffect(() => {
    const paramRef = ref(db, "parametres/mesures/" + name);
    const unsubscribe = onValue(
      paramRef,
      (snapshot) => {
        const data = snapshot.val();
        setEditedParam(data);
      },
      (error) => {
        console.error("Erreur lors du chargement des paramètres de mesure :", error);
      }
    );

    return () => unsubscribe();
  }, [name]);

  const handleChange = (e, field) => {
    setEditedParam((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
    setIsModified(true);
  };

  const handleSave = () => {
    if (editedParam) {
      const paramRef = ref(db, "parametres/mesures/" + name);

      // Si le nom a changé, on crée une nouvelle entrée
      if (localName !== name) {
        const newParamRef = ref(db, "parametres/mesures/" + localName);
        update(newParamRef, editedParam)
          .then(() => {
            console.log("Mesure renommée avec succès !");
            onChange(localName); // On notifie le parent que le nom a changé

            // Supprimer l'ancienne mesure après renommage
            remove(paramRef)
              .then(() => {
                console.log("Ancienne mesure supprimée avec succès !");
              })
              .catch((error) => {
                console.error("Erreur lors de la suppression de l'ancienne mesure :", error);
              });
          })
          .catch((error) => console.error("Erreur lors du renommage :", error));
      } else {
        // Sinon, on met juste à jour les autres paramètres
        update(paramRef, editedParam)
          .then(() => {
            console.log("Mise à jour réussie !");
          })
          .catch((error) => console.error("Erreur de mise à jour :", error));
      }

      setIsModified(false);
    }
  };

  const handleNameChange = (e) => {
    setLocalName(e.target.value); // Mettre à jour uniquement l'état local
    setIsModified(true); // Indique qu'il y a eu des modifications
  };

  const resetPosition = () => {
    const paramRef = ref(db, "parametres/mesures/" + name);
    const updatedParam = { ...editedParam, x: 0, y: 0 };

    // Mettre à jour la base de données
    update(paramRef, updatedParam)
      .then(() => {
        setEditedParam(updatedParam); // Mettre à jour l'état local
        localStorage.setItem("reload", true);
      })
      .catch((error) => console.error("Erreur lors de la réinitialisation de la position :", error));
  };

  return (
    <div className="mesure-settings">
      <label>
        <input type="checkbox" checked={isChecked} onChange={() => onChange(name)} /> Afficher {name}
        <br />
        <br />
        <label>Seuil Max</label>
        <input type="text" value={editedParam?.seuilMax || ""} onChange={(e) => handleChange(e, "seuilMax")} />
        <br />
        <label>Seuil Min</label>
        <input type="text" value={editedParam?.seuilMin || ""} onChange={(e) => handleChange(e, "seuilMin")} />
        <br />
        <label>Nom de la mesure</label>
        <input type="text" value={localName} onChange={handleNameChange} />
        <br />
        <button onClick={resetPosition} id="reset-position" title="Reinitialise la position de la mesure. La position sera réinitialisée à la fermeture des paramètres.">
          Réinitialiser la position
        </button>
      </label>

      {isModified && (
        <button onClick={handleSave}>Valider</button>
      )}
    </div>
  );
}

export default MesureSettings;
